module.exports = __webpack_public_path__ + "img/klaviyo.a5375fd2.png";